import React from "react";
import { connect } from "react-redux";
import { putData, showToast, postData } from "Source/globalFunction";
import _ from "lodash";
import Moment from "moment";

import Form from "./Form/Form";
import WorkingDays from "./WorkingDays/WorkingDays";
import AdjustedDates from "./AdjustedDates/AdjustedDates";
import Holidays from "./Modal/Holidays/Holidays";
import Subscriptions from "./Modal/Subscriptions/Subscriptions";
import DiscardChanges from "../Form/Modal/DiscardChanges/DiscardChanges";

const defaults = {
    holidays: [
        {date: null, name: null},
        {date: null, name: null},
        {date: null, name: null}
    ]
}

@connect(store => {
    return {
        project: store.project,
        projectSettings: store.projectSettings,
        loggedUser: store.loggedUser,
    };
})

class Calendar extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedCalendar: {},
            view:true,
            data:{}
        }
        _.map(["disregardChanges"], fn => {
            this[fn] = this[fn].bind(this);
        })
    
    }

    componentDidUpdate(prev){
        if(!_.isEqual(prev.isEdit, this.props.isEdit)){
            if(this.props.isEdit ==='calendar') {
                this.setState({view:false})
            } else {
                this.disregardChanges()
            }
        } else if (!_.isEqual(prev.isOpen, this.props.isOpen)){
            const {hasChanges}=this.props
            if(prev.isOpen && prev.isOpen ==='calendar' && Object.keys(hasChanges).filter(f=>hasChanges[f]).length < 1) {
              this.setState({view:true})
            }

        }
    }
  
    shouldComponentUpdate(nextProps){ 
        if(!_.isEqual(nextProps.scrollId, this.props.scrollId) && nextProps.scrollId) {
            if(this.refs[nextProps.scrollId]) {
                setTimeout(() => {
                    this.refs[nextProps.scrollId].scrollIntoView() 
                }, 100);
            }
        }
        if(!_.isEqual(nextProps.projectSettings.init, this.props.projectSettings.init) && Object.keys(nextProps.projectSettings.init).length && Object.keys(this.state.data).length==0){   
            this.setState({data:nextProps.projectSettings})
        }
        return true
    }
    componentWillUnmount(){
        const { dispatch, projectSettings } = this.props;
        dispatch({ type: "UPDATE_SETTINGS_INIT", data: projectSettings.init});
    }
   
    disregardChanges(){
        const { dispatch, projectSettings, loggedUser } = this.props;
        this.setState({view:true},()=>{
            if(this.props.triggerEdit) {
                this.props.triggerEdit({calendar:false})
             }
            dispatch({ type: "UPDATE_SETTINGS_INIT", data: projectSettings.init});

            $("#projectCalendarDiscard").modal("hide");
            showToast("success", "Changes have been discarded");
        });
    }
    render() {
        const { dispatch, projectSettings, loggedUser } = this.props;
        const defaultCalendarName = ((projectSettings.calendars.default || {}).calendars || {}).calendar;
        const defaultCalendarHolidays = (((projectSettings.calendars.default || {}).calendars || {}).calendar_holiday || []);
        const calendarHolidays = projectSettings.list.length;
        const currentSetting =  _.omit(projectSettings,['init','holidays'])
        const initHolidays= projectSettings.init && projectSettings.init.holidays ?projectSettings.init.holidays.filter(f=>f.date):[]
        const currentHolidays = projectSettings && projectSettings.holidays?projectSettings.holidays.filter(f=>f.date):[]
        const hasChanges = !_.isEqual(_.omit(projectSettings.init,['holidays']),currentSetting) || !_.isEqual(initHolidays,currentHolidays)
        if(this.props.editChange) {
            const changesProps = this.props.hasChanges
            const changes = changesProps.calendar
            if(changes !== (hasChanges && !this.state.view)) {
             this.props.editChange({calendar:hasChanges && !this.state.view})
            }
         }

        const getTotalHolidays = () => {
            let totalHolidays = [...defaultCalendarHolidays.map(e=>moment(e.date).format('MM/DD/YYYY')), ...projectSettings.holidays.filter(h => h.date).map(e=>moment(e.date).format('MM/DD/YYYY'))];

            for(const selected of projectSettings.calendars.others) {
                totalHolidays = [...totalHolidays, ...selected.calendar_holiday.map(e=>moment(e.date).format('MM/DD/YYYY'))]
            }
            return _.uniq(totalHolidays).length;
        }

        const handleViewHolidays = (selected) => {
            this.setState({...this.state, selectedCalendar: selected}, () => {
                $("#holidaysViewModal").modal("show");
            });
        }

        const handleViewSubscriptions = () => {
            $("#subscriptionsViewModal").modal("show");
        }
       const handleEdit=()=>{
        const changes = this.props.hasChanges
        
        if(Object.keys(changes).filter(f=>changes[f]).length>0) {  
            if(this.props.triggerEdit) {
                this.props.triggerEdit({calendar:true})
               }
             $('#accountSetting').modal("show")
         } else {
            if(this.props.triggerEdit) {
                this.props.triggerEdit({calendar:true})
               }
            this.setState({view:false})
         }
           
        }
       const handleCancel=()=>{
           if(hasChanges) {
            $("#projectCalendarDiscard").modal("show");
           } else {
            this.setState({view:true},()=>{
                if(this.props.onCancel) {
                    this.props.onCancel()
                }
                dispatch({ type: "UPDATE_SETTINGS_INIT", data: projectSettings.init});
            })
           }
           
        }

        const handleSave = () => {
            const url = `api/project/calendarSetting/${this.props.projectId}`;  
            const data = {
                calendars: projectSettings.calendars.others.map(c => c.id),
                holidays: projectSettings.holidays.filter(h => h.date).map(m=>{return {...m,holiday: m.holiday?m.holiday.trim():null}}),
                workdays: projectSettings.workingDays
            }


            dispatch({type: "SET_SCREEN_LOADER", Loading: true});

            putData(url, data, response => {
                if(response) {
                    const projectInit = {
                        calendars: {
                            default: response.data.project_calendar.default,
                            others: response.data.project_calendar.others.map(c => c.calendars)
                        }, 
                        workingDays: response.data.project_workdays,
                        holidays: [
                            ...response.data.project_holiday.filter(h => h.date).map(h => ({date: Moment(h.date).format("DD-MMM YYYY"), holiday: h.holiday})),
                            ...response.data.project_holiday.filter(h => h.date).length < 3 ? defaults.holidays.filter((h, i) => i >= response.data.project_holiday.filter(h => h.date).length && i < 3) : []
                        ]
                    }
                    dispatch({ type: "UPDATE_SETTINGS_INIT", data: projectInit});
                    this.setState({data:projectInit})
                    const data =[{
                            linkType: "project",
                            linkId: this.props.projectId,
                            actionType: "modified",
                            projectId:this.props.projectId,
                            activity:"Edited an account calendar setting"
                    }]
                    postData('/api/userActivity',{data})
                    showToast("success", "Account calendar settings saved!");
                }

                dispatch({type: "SET_SCREEN_LOADER", Loading: false});
                this.setState({view:true})
            });
        }
        const adjusted = projectSettings.workingDays.adjustedSetting
        const workDays = Object.keys(_.omit(projectSettings.workingDays,'id', 'adjustedSetting','dateAdded', 'dateUpdated')).filter(d=>{
            return projectSettings.workingDays[d] === 1
        })
        const label = workDays.map(w=>{
           return w[0].toUpperCase() + w.substring(1)
        }).join(", ")
       const view = this.state.view
       const canEdit = loggedUser.data.userRole < 4
       const hasError = projectSettings.holidays.filter(f=>f.error)
        return (
            <div id="calendar" class="settingsCalendar">
                <div class="pageHeader">
                    <h4>Calendar</h4>
                    {this.props.project.Selected.isActive && canEdit &&(
                        <div class="headerActions">
                            {view ? <div class="actionItem">
                                <a onClick={handleEdit}>
                                    <i class="material-icons">edit</i>
                                    <span>Edit</span>
                                </a>
                            </div> : <React.Fragment>

                                <div class="actionItem">
                                    <button class={`btn btnCancel ${hasChanges ? "active" : ""}`} onClick={handleCancel}>Cancel</button>
                                </div>
                                <div class="actionItem">
                                    <button class={`btn btnSave ${hasChanges && hasError.length===0 ? "active" : ""}`} onClick={handleSave}>Save</button>
                                </div>
                            </React.Fragment>
                            }
                        </div>
                    )}
                    
                </div>
                <div class="pageContainer">
                    <div class="calendarContainer">
                        <div class="calendarSection">
                            <div class="calendarDetails top">
                                <div class="detailItem">
                                    <label>Default Calendar</label>
                                    {defaultCalendarHolidays.length > 0 && <p>{defaultCalendarName} - <a onClick={() => handleViewHolidays(projectSettings.calendars.default.calendars)}>{defaultCalendarHolidays.length} Holiday/s</a></p>}
                                    {defaultCalendarHolidays.length === 0 && <p>{defaultCalendarName} - <span>{defaultCalendarHolidays.length} Holiday/s</span></p>}
                                </div>
                                <div class="detailItem">
                                    <label>Calendar Subscriptions</label>
                                    {calendarHolidays > 0 && <p><a onClick={handleViewSubscriptions}>View</a></p> }
                                    {calendarHolidays  === 0 && <p><span>View</span></p>}
                                </div>
                            </div>
                            <div class="calendarForm">
                                <Form holidays={projectSettings.holidays} view={view}/> 
                            </div>
                            <div class="calendarDetails bottom">
                                <div class="detailItem">
                                    <label>Total Holiday/s: {getTotalHolidays()}</label>
                                </div>
                            </div>
                        </div>

                        {view ?
                            <React.Fragment>
                                <div class="calendarSection">
                                    <strong> Working Days: </strong>
                                    <span class="ml30">{label}</span>
                                </div>
                                <div class="calendarSection mt20">
                                    <strong> Adjusted Dates: </strong>
                                    <span class="ml20">

                                        {adjusted === 'before' && <span>Automatically move due dates <strong>before</strong> holiday/s and non-working day/s (Recommended)</span>}
                                        {adjusted === 'after' && <span>Automatically move due dates <strong>after</strong> holiday/s and non-working day/s</span>}
                                        {adjusted === 'noChange' && <span>Don't move due dates</span>}

                                    </span>
                                </div>
                            </React.Fragment> :
                            <React.Fragment>
                                <div class="calendarSection bt bb ml30 mr30">
                                    <WorkingDays days={projectSettings.workingDays} />
                                </div>
                                <div class="calendarSection">
                                    <AdjustedDates value={projectSettings.workingDays.adjustedSetting} />
                                </div>
                            </React.Fragment>
                        }
                        
                    </div>
                </div>


                <Holidays calendar={this.state.selectedCalendar} />
                <Subscriptions calendars={projectSettings.list} selected={projectSettings.calendars.others} onView={handleViewHolidays} view={view}/>
                <DiscardChanges onCancel={this.disregardChanges} id={'projectCalendarDiscard'} />

            </div>
        );
    }
}

export default Calendar;